import { Component, OnInit, Input } from '@angular/core';
import { ToasterMessageService } from '@apply4u/services/toaster-message.service';
import { RecommendationModel } from '@apply4u/models/recommendation-model';
import { LoadingService } from '@apply4u/services/loading.service';
import { IsNotNull, IsNotNullOrEmpty } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { LiveHostName } from '@apply4u/models/shared';
import { UserConnection } from '@apply4u/models/userConnection';
import { RecommendationService } from '@apply4u/services/recommendation.service';
import { IsUrlHostNameExists, IsValidEmail } from '@apply4u/shared/helpers/common/common-helpers';

@Component({
  selector: 'share-job-modal',
  templateUrl: './share-job-modal.component.html',
  styleUrls: ['./share-job-modal.component.css']
})
export class ShareJobModalComponent implements OnInit {
  @Input() RecommendationModel = new RecommendationModel();
  @Input() PostUrl: string;
  UserConnection: UserConnection = new UserConnection();

  constructor(private toasterService: ToasterMessageService,
    private loadingService: LoadingService,
    private recommendationService: RecommendationService) {
  }

  ngOnInit(): void {
    if (IsNotNullOrEmpty(this.PostUrl) && IsUrlHostNameExists(this.PostUrl) == false) {
      this.RecommendationModel.RecommendedUrl = LiveHostName + this.PostUrl;
    }
  }

  SendRecommendationToUser(): void {
    if (IsNotNull(this.RecommendationModel)) {
      if (IsValidEmail(this.RecommendationModel.RecommendedtoEmail)) {
        if (IsNotNull(this.RecommendationModel.Title) && this.RecommendationModel.Title == "Job") {
          this.loadingService.Show();

          this.recommendationService.SendRecommendationForJob(this.RecommendationModel.RecommendedId, this.RecommendationModel.RecommendedUrl, this.RecommendationModel.RecommendedtoEmail, this.RecommendationModel.RecommendedbyUserId).subscribe(e => {
            this.loadingService.Hide();
            this.toasterService.Success("Recommendation sent successfully", null);
          }, error => {
            this.loadingService.Hide();
          });
        }
      } else {
        this.toasterService.Error(null, 'Please provide a valid Email Address');
      }
    }
  }
}
